<template>
  <background :type="'mobile'">
    <div class="mobile-content">
      <div class="title-section">
        <div class="back-button-container">
          <back-button />
        </div>
        <h1 class="onboarding-mobile-title">
          Woo, you’re all setup! <br /><br />Get the app and put a business phone system in your pocket!
        </h1>
        <img class="store-button" src="@/assets/images/app_store_button.png" />
      </div>
      <div class="submit-section">
        <a href="https://app.voyyp.com"
          ><custom-button class="start-button">
            Open Voyyp!
          </custom-button></a
        >
      </div>
    </div>
  </background>
</template>

<script>
import Background from '@/components/Background';
import BackButton from '@/components/BackButton';
import CustomButton from '@/components/CustomButton';
export default {
  name: 'OnboardingMobile',
  components: { CustomButton, Background, BackButton }
};
</script>

<style lang="scss" scoped>
.mobile-content {
  padding-top: 130px;
  padding-left: 70px;
  display: flex;
  flex-direction: column;
}

.onboarding-mobile-title {
  max-width: 550px;
  /*height: 195px;*/
  font-weight: 800;
  font-size: 40px;
  font-style: normal;
  line-height: 48px;
  letter-spacing: -0.5px;
  color: $colorTitle;
  margin-top: 55px;
  letter-spacing: -0.5px;
}
p {
  /*height: 30px;*/
  left: 70px;
  right: 741px;
  top: 445px;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #98a0ad;

  letter-spacing: 0.1px;
}

h1 {
  min-width: 317px;
}

.store-button {
  width: 165px;
  margin-top: 37px;
  margin-left: 4px;
}

.title-section {
  display: flex;
  flex-direction: column;
}

.submit-section {
  padding-top: 150px;
  display: flex;
  flex-direction: row;
  justify-content: right;
}

.start-button {
  position: fixed;
  right: 125px;
  bottom: 41px;
  width: 240px;
  height: 70px;
  border-radius: 8px;
}
</style>
